import React, { useState, useEffect } from 'react';
import styles from "./CountdownTimer.module.css"


const CountdownTimer = ({ initialTime }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime); 
  const [percentage, setPercentage] = useState(100); 

  useEffect(() => {

    const interval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(interval);
          return 0;
        }
        return prevTime - 100; 
      });
    }, 100); 
    return () => clearInterval(interval); 
  }, []);

  useEffect(() => {
    setPercentage((timeLeft / initialTime) * 100);
  }, [timeLeft, initialTime]);

  const radius = 25; 
  const strokeWidth = 5; 
  const padding = 10; 

  const svgSize = (radius + padding) * 2;

  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className={styles.container}>
      <svg
        width={svgSize} 
        height={svgSize} 
        className={styles.circle}
      >
        <circle
          cx={radius + padding} 
          cy={radius + padding}
          r={radius}
          stroke="#Ffffff"
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          cx={radius + padding}
          cy={radius + padding}
          r={radius}
          stroke="#f36621"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={styles.progressCircle}
        />
      </svg>
      <div className={styles.timerText}>
        {Math.ceil(timeLeft / 1000)}
      </div>
    </div>
  );
};

export default CountdownTimer;
